import React from 'react';
import { Modal, Table, Form, Empty, Input, Button, Tag } from 'antd';
import { APROBADO, REGISTRADO, ANULADO, RECHAZADO } from '../../../common/types/requerimientoEstadoType';

export default class ImportarRequerimientoModal extends React.Component {
    render() {
        const renderColor = (row) => {
            if (row.idRequerimientoEstado === REGISTRADO)
                return 'blue';
            if (row.idRequerimientoEstado === APROBADO)
                return 'green';
            if (row.idRequerimientoEstado === RECHAZADO)
                return 'orange';
            if (row.idRequerimientoEstado === ANULADO)
                return 'red';
        };

        return (
            <Modal
                title={"Búsqueda de Requerimiento para Importar"}
                visible={this.props.visible}
                style={{ top: 30 }}
                width="800px"
                onCancel={this.props.onCancel}
                footer={[
                    <Button
                        key="send"
                        type="primary"
                        onClick={this.props.onCancel}
                    >
                        Ok
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Input.Search
                                placeholder="Búsqueda por serie o documento"
                                autoComplete="off"
                                onChange={(e) => this.props.onChangeRequerimientoModal(e.target.value)}
                                onSearch={value => this.props.onSearchRequerimientoModal(value)}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Table
                                size="small"
                                style={{ overflowX: 'auto' }}
                                rowKey={record => record.id}
                                dataSource={this.props.formValues.dataSource}
                                rowSelection={{
                                    onChange: this.props.onChangeRow,
                                    selectedRowKeys: this.props.formValues.selectedRowKeys,
                                    hideDefaultSelections: false
                                }}
                                locale={{
                                    emptyText: <Empty
                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                        description="No se encontraron datos."
                                    />
                                }}
                                columns={[
                                    {
                                        title: 'Serie',
                                        dataIndex: 'serie',
                                        key: 'serie',
                                        sorter: true
                                    },
                                    {
                                        title: 'Documento',
                                        dataIndex: 'documento',
                                        key: 'documento',
                                        sorter: true
                                    },
                                    {
                                        title: 'Tipo Documento',
                                        dataIndex: 'tipoDocumentoCliente',
                                        key: 'tipoDocumentoCliente',
                                        sorter: true
                                    },
                                    {
                                        title: 'Número Documento',
                                        dataIndex: 'numeroDocumento',
                                        key: 'numeroDocumento',
                                        sorter: true
                                    },
                                    {
                                        title: 'Entidad',
                                        dataIndex: 'razonSocial',
                                        key: 'razonSocial',
                                        sorter: true,
                                        render: (value) => (
                                            <div style={{ minWidth: "150px" }}>{value}</div>
                                        )
                                    },
                                    {
                                        title: 'Fecha',
                                        dataIndex: 'fechaStr',
                                        key: 'fechaStr',
                                        sorter: true
                                    },
                                    {
                                        title: 'Estado',
                                        dataIndex: 'nombreRequerimientoEstado',
                                        key: 'nombreRequerimientoEstado',
                                        align: 'center',
                                        width: "90px",
                                        fixed: 'right',
                                        render: (value, row) => {
                                            return (<div className="custom-options" >
                                                <Tag color={renderColor(row)}>{value}</Tag>
                                            </div>)
                                        }
                                    }
                                ]}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}